import { render, staticRenderFns } from "./SkuSetting.vue?vue&type=template&id=104d759c&scoped=true"
import script from "./SkuSetting.vue?vue&type=script&lang=js"
export * from "./SkuSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuSetting.vue?vue&type=style&index=0&id=104d759c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d759c",
  null
  
)

export default component.exports